<template>
    <div class="gglist">
    <div class="top" v-show="dataLoding == 1">
        <Table border :columns="adColumns" :data="this.tableList.tableData"></Table>
        <Page  size="small" @on-change="changePage" @on-page-size-change="changeSize" :total="page.total"  :show-total="true" :current="page.current" :page-size="page.pageSize"  placement="top" class="pagesimg"/>
    </div>
   <Spin fix class="bottom" v-show="dataLoding == 2">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
    <AdModelBox :showAdModel.sync="adBox.showAdModel" :pos_type.sync="adBox.pos_type" :type="2"  :editFormData="adBox.editFormData" :pos_id="adBox.posid" :fn="adBox.callbackAdFn" ></AdModelBox>
    </div>
</template>

<script>
/**规格属性伸缩框
 * @param params Object 所属的广告位的id
 *
 * set-ad-params Function 删除调用的父类方法
 *
 */
import common from '../../common/common.js'
import AdModelBox from '../position/addAdModel';
import vm from "../../event.js";
    export default {
        name:'editad',
        components: {
            AdModelBox
        },
        props: {
            params: Object, // 当前点击的 那条数据 （对象）
        },
        data () {
        return {
            dataLoding:2,
            loading: true,
            type:1,//弹框打开类型 1添加 2编辑
            tableList:{//表格组
                hasSelectData:{},//已选中的行的数据
                tableData: []//表格数据
            },
            adBox:{//广告弹框组
                    posid:0,//上级广告位的ID
                    showAdModel:false,//广告弹框开关
                    editFormData:{},
                    pos_type:1,
                    callbackAdFn:()=>{}, //广告弹框的回调函数
                },
            page:{//分页排序
                    total:0,//总条数
                    pageSize:20,//每页条数
                    current:1,//当前页
                    key:'sort_num',
                    order:'desc'
                },
            adColumns: [
                {
                    title: '标题',
                    key: 'title',
                    width:100,
                },
                {
                    title: '链接',
                    key: 'url',
                    width: 80,
                    render: (h, params) => {
                        if(this.params.row.type_id == 1 && params.row.url.indexOf('http')!=-1){
                            return h('a',{
                                attrs:{
                                    href:params.row.url,
                                    target:'_blank'
                                }
                            },[
                                h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                        }
                                    },'访问')
                            ])
                        }else{
                            return h('span','--')
                        }
                    }

                },
                {
                    title: '内容',
                    key: 'content',
                    width: 80,
                    render: (h, params) => {
                        if(this.params.row.type_id == 1){
                            return h('img',{
                                attrs:{
                                    src:this.config.sourceUrl+params.row.content
                                },
                                style:{
                                    width:'40px',
                                    height:'40px'
                                }
                            })
                        }else{
                            return h('Button',{
                                props:{
                                    type: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.$Modal.info({
                                            title: '查看',
                                            content: params.row.content
                                        })
                                    }
                                }
                            },'查看')
                        }
                    }
                },
                {
                    title: '排序',
                    key: 'sort_num',
                    width: 80,
                    sortable:true
                },
                {
                    title: '状态',
                    key: 'status',
                    width: 80,
                    sortable:true,
                    render: (h, params) => {
                        let color = '#13C351'
                        let status = '正常'

                        switch (params.row.status){
                            case 1:
                            color = '#13C351'
                            status = '显示'
                            let endDate = new Date(params.row.end_time)
                            //当前时间
                            let nowDate = new Date()
                            if(endDate < nowDate){
                                color = '#f00'
                                status = '已过期'
                            }

                            break
                            case 2:
                            color = '#f00'
                            status = '隐藏'
                            break
                            default:
                            color = '#f00'
                            status = '未知'

                        }
                        return h('span', {style:{color:color}},status);
                    }
                },
                {
                    title: '有效期',
                    key: 'start_time',
                    minWidth: 240,
                    sortable:true,
                    render: (h, params) => {
                        return h('span',params.row.start_time+' - '+params.row.end_time)
                    }
                },
                {
                    title: '添加时间',
                    key: 'created_at',
                    minWidth: 140,
                    sortable:true
                },
                {
                    title: '操作',
                    key: 'action',
                    minWidth: 130,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.addAdData(params)
                                    }
                                }
                            }, '编辑'),
                            h('Poptip',{
                                props:{
                                    confirm:true,
                                    title:'确定删除?',
                                },
                                on:{
                                    'on-ok':()=>{
                                        this.remove(params)//删除广告
                                    }
                                }},
                                [h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    }
                                }, '删除')])

                        ]);
                    }
                }
            ]
        }
    },
    methods: {
        //接收数据的方法
        receive() {
            vm.$on('two-to-one',(data)=>{
                this.getData();
            })
        },
        getData () {//获取广告
            let getData = {
                    params:{
                        page:this.page.current,
                        pagesize:this.page.pageSize,
                        sortfield:this.page.key,
                        ascDesc:this.page.order,
                        position_id:this.params.row.id
                        }
                }
                this.axios.get(this.config.urlArray.ggShow,getData).then((result) => {
                    common.ajaxMsg(result.data);
                    let resData = result.data.data.list
                    //处理数组
                    this.$nextTick(() => {
                        this.tableList.tableData = resData
                        this.dataLoding = 1
                    })
                    this.page.total = result.data.data.total
                    this.loading = false
                }).catch((err) => {
                    common.msg('error','广告获取失败',()=>{})
                });
        },
        addAdData (params) {  //编辑广告
                this.adBox.showAdModel = true
                this.adBox.posid = params.row.position_id
                this.adBox.pos_type = this.params.row.type_id
                this.adBox.editFormData = params.row
                this.adBox.callbackAdFn = () => {//回调处理
                    //重新载入
                    this.adBox.showAdModel = false;
                }
            },
        remove (params) {//删除广告的方法
            let delData = {
                id:params.row.id,
            }
            this.axios.post(this.config.urlArray.ggDestroy,delData).then((result)=>{
                common.ajaxMsg(result.data,true,()=>{
                    this.tableList.tableData.splice(params.index, 1);
                })
            }).catch((err)=>{
                common.msg('error','删除失败')
            })

        },
        changePage (nowpage) {//切换分页
            this.page.current = nowpage
            this.getData()
        },
        changeSize (nowSize) {//切换每页显示条数
            this.page.pageSize = nowSize
            this.page.current = 1
            this.getData()
        }
    },
    mounted(){
       this.getData();
       this.receive();
    }
    }
</script>
<style scope>
.ivu-poptip-confirm .ivu-poptip-body .ivu-icon{
    left: 20px;
}
td.ivu-table-expanded-cell{
    padding: 10px !important;
}
.gglist .ivu-table th{
    height: 30px !important;
}

</style>


